import { render } from "./ComMoreButton.vue?vue&type=template&id=6d829ac1&ts=true"
import script from "./ComMoreButton.vue?vue&type=script&lang=ts"
export * from "./ComMoreButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__